import React from 'react';
import PropTypes from 'prop-types';

import { TeamIcon } from '../../../../../../common/react/components/TeamIcon';

export const FixtureTeam = ({ team, theme }) => {
    return (
        <>
            <TeamIcon
                className="fixtures__match-team-logo"
                providerId={team.providerId}
                theme={theme}
            />
            <span>{team.name}</span>
        </>
    );
};

FixtureTeam.propTypes = {
    team: PropTypes.object.isRequired,
    theme: PropTypes.string
};
